const states = {
  referrer: {              // 来源页面
    31: 'crispyRice',      // 脆香米领取活动
  },
  inSuccessText: {
    crispyRice: {
      headMsg: '领取成功',
    }
  }
};
export default states;
